/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import CourseDetails from './CourseDetails';
import {getCourseDetails,addNewInstructorCourseDetails} from "../../../_thunks/coursedetails.thunk";
import { changeCourseEndDate } from "../../../_actions/coursedetails.actions";
import { showMessage } from "../../../_actions//message.actions";

function mapStateToProps(state, props) {
    return {
        registrarCourseSectionDetails : state.registrarCourseSectionDetails.courseDetails,
        courseChangesDetails: state.registrarCourseSectionDetails.courseChangesDetails,
        hasPrivateResources: state.activeCollection.hasPrivateResources
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getCourseDetails: (collectionId) => {
            dispatch(getCourseDetails(collectionId));
        },
        changeCourseEndDate:(updatedCourseDetails)=>{
            dispatch(changeCourseEndDate(updatedCourseDetails));
        },
        addNewInstructorCourseDetails: (instructorDetails) => {
            dispatch(addNewInstructorCourseDetails(instructorDetails));
        },
        showExistsMessage:(msgDetails)=>{
            dispatch(showMessage(msgDetails));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetails);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/CourseDetailsLink.js